<template>
  <div>
    <template v-if="picList.length">
      <template v-if="picList.length === 1">
        <c-block-box
          :title="picmap[1] ? picmap[1].dictLabel : ''"
          class="margin-bottom-1rem"
        >
          <div style="height: 46.5rem;overflow-y: auto;border-radius: 0 0 0.5rem 0.5rem">
            <img
              v-for="(img, index) in picmap[1].fieldA"
              :src="img"
              :key="index"
              style="width: 100%"
            />
          </div>
        </c-block-box>
      </template>
      <div class="pages-box" v-else>
        <div class="pages-item margin-right-1rem">
          <c-block-box
            :title="picmap[1] ? picmap[1].dictLabel : ''"
            class="margin-bottom-1rem"
          >
            <div style="height: 13rem;overflow: hidden;">
              <img
                v-for="(img, index) in picmap[1].fieldA"
                :src="img"
                :key="index"
                style="width: 100%"
              />
            </div>
          </c-block-box>
          <c-block-box
            :title="picmap[2] ? picmap[2].dictLabel : ''"
            :icon="true"
          >
            <div style="height: 30rem;overflow: hidden;border-radius: 0 0 0.5rem 0.5rem">
              <img
                v-for="(img, index) in picmap[2].fieldA"
                :src="img"
                :key="index"
                style="width: 100%"
              />
            </div>
          </c-block-box>
        </div>
        <div class="pages-item">
          <c-block-box
            :title="picmap[3] ? picmap[3].dictLabel : ''"
            :icon="true"
          >
            <div style="height: 46.5rem;overflow-y: auto;border-radius: 0 0 0.5rem 0.5rem">
              <img
                v-for="(img, index) in picmap[3].fieldA"
                :src="img"
                :key="index"
                style="width: 100%"
              />
            </div>
          </c-block-box>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  components: {},
  props: {},
  data () {
    return {
      picmap: {},
      picList: []
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {},
  activated () {
    this.picmap = {}
    this.picList = []
    const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
    this.$service.fetch({
      url: 'api/digitalMarketing/dashboard?month=' + yearMonth
    }).then(res => {
      this.picList = res[this.$route.query.type]
      res[this.$route.query.type].forEach((item, index) => {
        this.$set(this.picmap, index + 1, {
          dictLabel: item.dictLabel,
          fieldA: JSON.parse(item.fieldA)
        })
      })
      this.$nextTick(() => {
        this.$parent.bindKey(this.isAndroid ? 'back' : 'select-mounth')
      })
    })
  },
  destroyed () {
  }
}
</script>

<style lang="stylus" scoped>
@import './stylus/ClosedLoopRate.styl'
</style>
